import React, {Component} from 'react';
import {Form, Input, InputGroup, InputGroupAddon, FormGroup, Button, Card, CardHeader, CardBody, CardFooter} from "reactstrap";
import {FormattedMessage} from "react-intl";
import api from 'api';
import setAuthorizationHeader from "utils/setAuthorizationHeader";
import PropTypes from 'prop-types';

class RegisterForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data: {
        email: '',
        newsletter: true,
        regulations: true
      },
      loading: false,
      errors: {},
      registered: false
    };

    this.onChange = this.onChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e){
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    })
  }

  onCheckboxChange(e){
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.checked }
    })
  }

  onSubmit(e){
    e.preventDefault();

    const formData = new FormData();
    formData.append('email', this.state.data.email);
    formData.append('newsletter', this.state.data.newsletter);
    formData.append('regulations', this.state.data.regulations);

    this.setState({ loading: true, errors: {} });
    api.surveyResponse.respondent.register(formData, this.props.surveyResponse.id)
      .then(data => {
        localStorage.jwt = data.token;
        setAuthorizationHeader(data.token);
        window.location.assign(data.redirect);
      })
      .catch((error) => {
        let errors = {};
        Object.keys(error.response.data.form.errors).map(x => {
          errors[x] = error.response.data.form.errors[x]
        });
        this.setState({errors, loading: false});
      });
  }

  render() {
    const {data, errors, loading, registered} = this.state;
    const earnedPoints = this.props.survey.endCashPoints > 0 || this.props.survey.endSocialPoints > 0;
    const earnedBothTypesOfPoints = this.props.survey.endCashPoints > 0 && this.props.survey.endSocialPoints > 0;

    return registered ? <div><FormattedMessage id="survey.registerForm.registered" /></div> :
      <Card className="w-50 mx-auto mt-4">
        <CardHeader className="p-3">
          <h3><FormattedMessage id="survey.registerForm.cardHeader" /></h3><hr/>
        </CardHeader>
        <CardBody className="pt-0">
          <div className="mb-4">
            {earnedPoints && <div>
              <FormattedMessage id="survey.registerForm.cardBody" />
              {this.props.survey.endCashPoints > 0 && <React.Fragment>{this.props.survey.endCashPoints} <FormattedMessage id="_.cashPoints" /> ({this.props.survey.endCashPoints / 2} <FormattedMessage id="_.pln" />)</React.Fragment>}
              {earnedBothTypesOfPoints && <React.Fragment> <FormattedMessage id="_.and" /> </React.Fragment>}
              {this.props.survey.endSocialPoints > 0 && <React.Fragment>{this.props.survey.endSocialPoints} <FormattedMessage id="_.socialPoints" /></React.Fragment>}!
            </div>}
            <div><FormattedMessage id="survey.registerForm.cardBody2" /></div>
          </div>
          <Form onSubmit={this.onSubmit}>
            <FormGroup row id="email">
              <InputGroup className="mb-3">
                <InputGroupAddon addonType="prepend">
                  <div className="input-group-text"><i className="fas fa-envelope" /></div>
                </InputGroupAddon>
                <FormattedMessage id="survey.registerForm.label.email">{
                  (message) =>
                    <Input type="text" id="email" name="email" placeholder={message} invalid={!!errors.email} value={data.email} onChange={this.onChange}/>
                }</FormattedMessage>
                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
              </InputGroup>
            </FormGroup>

            <FormGroup row id="newsletter">
              <InputGroup className="ml-4">
                <Input type="checkbox" id="newsletter" name="newsletter" onChange={this.onCheckboxChange} checked={data.newsletter} className="w-auto"/>
                <FormattedMessage id="survey.registerForm.label.newsletter" />
              </InputGroup>
            </FormGroup>

            <FormGroup row id="regulations">
              <InputGroup className="ml-4">
                <Input type="checkbox" id="regulations" name="regulations" onChange={this.onCheckboxChange} checked={data.regulations} className="w-auto"/>
                <FormattedMessage id="survey.registerForm.label.regulations" />
              </InputGroup>
              {errors.regulations && <p className="small text-danger">{errors.regulations}</p>}
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter>
          <Button disabled={loading} className="btn btn-success btn-ladda btn-block" onClick={this.onSubmit}>
            <FormattedMessage id="survey.registerForm.button.register" />
          </Button>
        </CardFooter>
      </Card>
  }
}

RegisterForm.propTypes = {
  surveyResponse: PropTypes.object.isRequired,
  survey: PropTypes.object.isRequired
};

export default RegisterForm;